
import React, { useState } from 'react';
import { Dialog } from '@/components/ui/dialog';
import { AddCategoryDialog } from '@/components/AddCategoryDialog';
import { EditCategoryDialog } from '@/components/EditCategoryDialog';
import { Category } from '@/types';
import { toast } from 'sonner';

interface CategoryDialogManagerProps {
  categories: Category[];
  onAddCategory: (name: string, parentId: string | null, type: 'Afdracht' | 'Geen afdracht') => void;
  onEditCategory?: (categoryId: string, newName: string, newParentId: string | null, newType: 'Afdracht' | 'Geen afdracht') => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedCategory?: Category | null;
  editDialogOpen?: boolean;
  onEditDialogOpenChange?: (open: boolean) => void;
}

export const CategoryDialogManager: React.FC<CategoryDialogManagerProps> = ({
  categories,
  onAddCategory,
  onEditCategory,
  open,
  onOpenChange,
  selectedCategory,
  editDialogOpen = false,
  onEditDialogOpenChange,
}) => {
  const handleEditCategory = (categoryId: string, newName: string, newParentId: string | null, newType: 'Afdracht' | 'Geen afdracht') => {
    if (onEditCategory) {
      onEditCategory(categoryId, newName, newParentId, newType);
      toast.success('Category updated successfully');
      onEditDialogOpenChange?.(false);
    }
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <AddCategoryDialog
          categories={categories}
          onAddCategory={onAddCategory}
          open={open}
          onOpenChange={onOpenChange}
        />
      </Dialog>

      <EditCategoryDialog
        category={selectedCategory}
        categories={categories}
        onEditCategory={handleEditCategory}
        open={editDialogOpen}
        onOpenChange={onEditDialogOpenChange || (() => {})}
      />
    </>
  );
};
